import { Heading } from "cai-fusion"
import { useNavigate, NavLink } from "react-router-dom";

import { ReactComponent as IconSummary } from "../../../../images/icon-summary.svg"
import { useSiftV2 } from "../../contexts/siftV2Context";

const SiftNewOpportunity = () => {

    const { processTypes } = useSiftV2();
    const navigate = useNavigate();
    
    return (
        <div className="o-page-section o-page-section l-pt-none">
            <div className="o-page-section__content-container o-page-section__content-container--narrow l-pt-none l-mt-neg-sm">
                <div className="l-row l-pt-sm">
                    <div className="col-md-12">
                        <Heading size={1}>New Opportunity</Heading>
                        <p className="a-medium-text a-muted-text">To get started, select the type of opportunity you want to create a summary for.</p>
                        <div className="row">
                            <div className="col-md-12">
                                <div className="o-tile-grid l-mt-xs l-pb-xl">
                                    {processTypes.map((oppType) => (
                                        <TileItem 
                                            key={oppType.id}
                                            IconElement={IconSummary}
                                            title={oppType.name}
                                            description={oppType.description}
                                            path={oppType.id}
                                        />
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}


const TileItem = ({path, IconElement, title, description}) => {

    return (
        <NavLink 
            className="m-tile o-tile-grid__tile"
            to={`/${process.env.REACT_APP_BRANDING_SIFT_PATH ?? "sift"}/types/${path}/new`}
        >
            <div className="m-tile__icon-wrapper">
                <IconElement className="m-tile__icon" />
            </div>
            <Heading size={5} className="m-tile__title">{title}</Heading>
            <p className="m-tile__description">{description}</p>
            <span className="m-tile__cta">Get Started</span>
        </NavLink>
    )
}

export default SiftNewOpportunity;